import L from 'leaflet';

import { IncidentType } from '@cobliteam/api-lib';

import incidentPluggedIconUrl from '../icons/ic-plugged.svg';
import incidentUnpluggedIconUrl from '../icons/ic-unplugged.svg';

const getIcon = (type: IncidentType): string => {
  switch (type) {
    case IncidentType.DEVICE_UNPLUGGED:
      return incidentUnpluggedIconUrl;
    case IncidentType.DEVICE_PLUGGED:
      return incidentPluggedIconUrl;
    default:
      return '';
  }
};

export const IncidentIcon = (type: IncidentType) => {
  return new L.DivIcon({
    html: `<div><img src="${getIcon(type)}"/></div>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });
};

export const IncidentIconComponent = ({ type }: { type: IncidentType }) => {
  return <img className='-mr-2 size-10' src={getIcon(type)} />;
};
